import { render } from "./AutomationLanding.vue?vue&type=template&id=4cc109ec&scoped=true"
import script from "./AutomationLanding.vue?vue&type=script&lang=js"
export * from "./AutomationLanding.vue?vue&type=script&lang=js"

import "./AutomationLanding.vue?vue&type=style&index=0&id=4cc109ec&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cc109ec"]])

export default __exports__